<ng-container *ngIf="weather$ | async as weather">
  <ng-container *ngIf="weather.main">
    <div class="card jumbotron">
      <ng-container *ngIf="first(weather.weather)?.icon as icon; else template">
        <img src="assets/images/backgrounds/{{ map[icon] }}.png" class="card-img" alt="" />
      </ng-container>
      <ng-template #template>
        <img src="assets/images/backgrounds/weather.png" class="card-img" alt="" />
      </ng-template>

      <div class="overlay w-100 gradient-x-0">
        <div class="card-body">
          <div class="row align-items-end">
            <div class="col-auto text-white text-center">
              <div class="bg-black bg-opacity-25 rounded px-3 py-2">
                <div class="d-flex">
                  <h1 class="lh-1 fw-bolder m-0" [style.font-size]="'52px'">
                    {{ weather.main.temp | number: '1.0-0' }}
                  </h1>
                  <span class="font-size-10 mt-1 ms-1">F</span>
                </div>
                <p class="m-0">{{ first(weather.weather)?.main }}</p>
              </div>
            </div>
            <div class="col text-end text-white">
              {{ weather.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
